export function sendEmailToFirstPromoter(email: string) {
  window.fpr("referral", { email: email });
}
